import React from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { DateRangeType } from 'src/common/components/DateRangeTypePicker';

import { SEHomeCard } from '../../../common/components/SEHomeCard';
import { getDateRangeTypeAriaLabel, getDateRangeTypeLabel } from '../ev-charger-helper';
import { ChargingActivitySessionData } from '../types';

type Props = {
  readonly chargingSession: ChargingActivitySessionData;
  readonly selectedDateRangeType: DateRangeType;
};

export function ChargingSessionCard({ chargingSession, selectedDateRangeType }: Props) {
  const textColor = useColorModeValue('customGrey.700', 'customGrey.400');
  const dateRangeTypeLabel = getDateRangeTypeLabel(selectedDateRangeType, chargingSession.start, chargingSession.id);

  const dateRangeTypeAriaLabel = getDateRangeTypeAriaLabel(
    selectedDateRangeType,
    chargingSession.start,
    chargingSession.end
  );

  return (
    <SEHomeCard width="100%" mb={3} borderTopLeftRadius={5}>
      <Box data-testid={`charging-session-${chargingSession.id}`}>
        <Flex justifyContent="space-between" mt={2}>
          <Text fontSize="17" fontWeight="medium" data-testid="session-date-label">
            {dateRangeTypeLabel.toUpperCase()}
          </Text>
          <Text fontSize="17" fontWeight="medium" data-testid="session-energy-and-cost-label">
            {chargingSession.usage.toLocaleString('en-US')} kWh | ${chargingSession.cost}
          </Text>
        </Flex>
        <Text fontSize="sm" color={textColor} mt={1} data-testid="session-aria-label">
          {dateRangeTypeAriaLabel}
        </Text>
      </Box>
    </SEHomeCard>
  );
}
